import type { ActivityKind, ApiActivity, ApiCartela, ApiPlayer, SimulationResult } from '../../shared/types';
import { get, post } from '../../shared/api/http';

export interface ManualIssueInput { playerId: string; missionId?: string; qty: number; note: string; }

export interface SimulateInput {
  externalId: string;
  playerName: string;
  kind: ActivityKind;
  value?: number;
  sourceRef?: string;
}

/** Jogadores, suas cartelas e atividades; emissão manual; simulador (dev). */
export const playersApi = {
  list: (search?: string): Promise<ApiPlayer[]> => get(`/players${search ? `?search=${encodeURIComponent(search)}` : ''}`),
  get: (id: string): Promise<ApiPlayer> => get(`/players/${id}`),
  activities: (id: string): Promise<ApiActivity[]> => get(`/players/${id}/activities`),
  stats: (): Promise<{ players: number; cartelasActive: number; cartelasTotal: number }> => get('/players/stats'),
  cartelas: (params: { playerId?: string; status?: 'ACTIVE' | 'WON' | 'VOID'; search?: string; limit?: number } = {}): Promise<ApiCartela[]> => {
    const qs = Object.entries(params).filter(([, v]) => v !== undefined && v !== '').map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`).join('&');
    return get(`/cartelas${qs ? `?${qs}` : ''}`);
  },
  issue: (input: ManualIssueInput): Promise<ApiCartela[]> => post('/cartelas/issue', input),
  simulate: (input: SimulateInput): Promise<SimulationResult> => post('/cartelas/simulate', input),
};
